import { Component } from '@angular/core';

@Component({
  selector: 'app-disrupt-kerala',
  standalone: true,
  imports: [],
  templateUrl: './disrupt-kerala.component.html',
  styleUrl: './disrupt-kerala.component.scss'
})
export class DisruptKeralaComponent {

}
